import * as routes from "../../constants/routes";
import ActionButton from "../ActionButton";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import React, {useEffect} from "react";
import styles from "./NotFoundPage.module.css";
import usePageView from "../../lib/usePageView";
import {Container, Column, Row} from "../grid";

const strings = {
    title: "1st Financial Bank USA",
    header: "Page not found",
    body:
        "Sorry, this page does not exist. Please click the link below to return to our home page and begin your application.",
    startNew: "Start a New Application",
};

export default function NotFoundPage() {
    useEffect(() => {
        document.title = strings.title;
    }, []);
    usePageView(strings.title);
    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row className={styles.titleRow}>
                    <Column>
                        <h1 className={styles.title}>{strings.header}</h1>
                        <div className={styles.body}>{strings.body}</div>
                    </Column>
                </Row>
                <Row>
                    <Column>
                        <ActionButton
                            label={strings.startNew}
                            linkTo={routes.ORGANIC_APP}
                            openInSameTab={true}
                        />
                    </Column>
                </Row>
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
